export default __webpack_public_path__ + "static/rsmethurst-7b264053a9480467765449636273a39b.png";